export enum TranslationMutationTypes {
    SET_TRANSLATIONS = 'SET_TRANSLATIONS',
}